import React, { useState } from 'react';
import { Placemark } from 'react-yandex-maps';

import warningSuccessIcon from '../../../../assets/images/map/warningSuccess.svg';
import almostFinishedIcon from '../../../../assets/images/map/almostFinished.svg';
import disabledIcon from '../../../../assets/images/map/disabled.svg';
import successIcon from '../../../../assets/images/map/success.svg';
import styles from './Point.scss';
import { loadPoint } from '../../../../actions/objects';
import { useDispatch, useSelector } from 'react-redux';
import { ROOT_URL } from '../../../../constants/Config';
import nothingFoundImage from 'assets/images/non-photo.png';
import { pluralize, formatNumber } from 'utils';

const truncateString = (str, maxLength = 20) =>
  str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;

const getIcon = (contexuality) => {
  if (contexuality === 'almostFinished') {
    return almostFinishedIcon;
  }

  if (contexuality === 'success') {
    return successIcon;
  }

  if (contexuality === 'warningSuccess' || contexuality === 'warningActive') {
    return warningSuccessIcon;
  }

  return disabledIcon;
};

const size = [20, 20];
const activeSize = [26, 26];

const YMapPoint = React.memo(({ id, lat, lng, onClick, contexuality, isActive }) => {
  const dispatch = useDispatch();
  const pointData = useSelector((state) => state.objects.points[id]);

  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
    if (!pointData) {
      dispatch(loadPoint(id));
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const imageUrl = pointData
    ? pointData.image
      ? `${ROOT_URL}/image?id=${pointData.image.id}&size=small`
      : nothingFoundImage
    : '';

  return (
    <Placemark
      geometry={[+lat, +lng]}
      onClick={() => onClick(id, pointData)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      properties={{
        iconContent: hovered
          ? pointData
            ? `
                <div class="${styles.iconContent}">
                  <div class="${styles.header}">
                    <div class="${styles.imageContainer}">
                      ${
                        imageUrl
                          ? `<img 
                              alt="house" 
                              class="${styles.image}" 
                              src="${imageUrl}"
                            />`
                          : ''
                      }
                    </div>
                    <div class="${styles.headerInfo}">
                      <div class="${styles.title}">
                        ${pointData && pointData.title ? truncateString(pointData.title, 23) : ''}
                      </div>
                      <div class="${styles.subtitle}">
                        ${
                          pointData && pointData.address
                            ? truncateString(pointData.address, 27)
                            : ''
                        }
                      </div>
                      <div class="${styles.labels}">
                      ${pointData.view_action ? `<div class="${styles.promo}">Акция</div>` : ''}
                      ${
                        pointData.status === 3
                          ? `<div class="${styles.almostFinished}">Частично сдан</div>`
                          : pointData.construction_finished
                          ? `<div class="${styles.finished}">Сдан</div>`
                          : `<div class="${styles.endDate}">
                              ${pointData.construction_ending} / ${pointData.year_built}
                            </div>`
                      }
                      </div>
                    </div>
                  </div>
                  <div class="${styles.footer}">
                    ${
                      pointData.count_flats
                        ? `
                          <div class="${styles.footerLeft}">
                            <div class="${styles.flats}">
                              ${pointData.count_flats} ${pluralize(
                            pointData.count_flats,
                            'Квартира',
                            'Квартиры',
                            'Квартир'
                          )}
                            </div>
                            <div class="${styles.areas}">
                              ${pointData.min_square} м² - ${pointData.max_square} м²
                            </div>
                          </div>
                          <div class="${styles.footerRight}">
                            <div class="${styles.priceFrom}">
                              От ${formatNumber(pointData.cost_min)} ${
                            (pointData.country && pointData.country.country_currency_symbol) || ''
                          }
                            </div>
                            <div class="${styles.pricePerMeter}">
                              ${formatNumber(pointData.min_area_cost)} ${
                            (pointData.country && pointData.country.country_currency_symbol) || ''
                          } за м²
                            </div>
                          </div>`
                        : `<div class="${styles.soldOut}">Все лоты проданы</div>`
                    }
                  </div>
                </div>`
            : `<div class="${styles.iconContentLoading}">
                  <span class="${styles.loader}"></span>
                </div>`
          : '',
      }}
      options={{
        iconLayout: 'default#imageWithContent',
        iconImageSize: isActive ? activeSize : size,
        iconImageOffset: isActive ? [-13, -13] : [-10, -10],
        iconImageHref: getIcon(contexuality),
      }}
    />
  );
});

export default YMapPoint;



// WEBPACK FOOTER //
// ./src/components/common/YMap/YMapPoint/index.js